var _rect, _rect2, _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 47,
    viewBox: "0 0 30 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27.8889,
    height: 6.97222,
    fill: "#4A4D52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 38.8492,
    width: 27.8889,
    height: 5.97619,
    fill: "#4A4D52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 41.8373H19.4262",
    stroke: "#FFFDFD",
    strokeWidth: 1.99206,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9442,
    cy: 3.98804,
    r: 1.99206,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.8492V43.3314C1 44.4315 1.89188 45.3234 2.99206 45.3234H26.8968C27.997 45.3234 28.8889 44.4315 28.8889 43.3313V38.8492M1 38.8492H28.8889M1 38.8492V7.47421M28.8889 38.8492V7.47421M28.8889 7.47421V2.99206C28.8889 1.89188 27.997 1 26.8968 1H2.99206C1.89187 1 1 1.89188 1 2.99206V7.47421M28.8889 7.47421H1",
    stroke: "#4A4D52",
    strokeWidth: 1.99206
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.8492V43.3314C1 44.4315 1.89188 45.3234 2.99206 45.3234H26.8968C27.997 45.3234 28.8889 44.4315 28.8889 43.3313V38.8492M1 38.8492H28.8889M1 38.8492V7.47421M28.8889 38.8492V7.47421M28.8889 7.47421V2.99206C28.8889 1.89188 27.997 1 26.8968 1H2.99206C1.89187 1 1 1.89188 1 2.99206V7.47421M28.8889 7.47421H1",
    stroke: "#4A4D52",
    strokeWidth: 1.99206
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6217 13L8 23.6217L14.5928 23.988L9.0988 32.7783L21.9181 21.0578H14.959L18.6217 13Z",
    fill: "#4A4D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.b1f24ef9e2cfc4575d8a4e9d0e17928b.svg";
export { ForwardRef as ReactComponent };